import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { INDPARENT, STUDENTS } from "../graphql/queries";

export const useFetchSubscribers = (user, isTeacher) => {
  const [subscribers, setSubscribers] = useState([]);
  const [getIndParent] = useLazyQuery(INDPARENT, {
    onCompleted: async (data) => {
      if (data.indParents.length > 0 && data.indParents[0].pupil.length > 0) {
        setSubscribers(
          data.indParents[0].pupil.map((p) => ({ ...p, isChecked: false }))
        );
      }
    },
    onError: () => {
      // do nothing
    },
    fetchPolicy: "cache-and-network",
  });

  const [getStudents] = useLazyQuery(STUDENTS, {
    onCompleted: async (data) => {
      setSubscribers(
        data.getPlusOrgSubscribers.map((p) => ({ ...p, isChecked: false }))
      );
    },
    onError: () => {
      // do nothing
    },
    fetchPolicy: "cache-and-network",
  });

  const selectSubscriber = (id, isChecked) => {
    let subscribersCopy = [...subscribers];
    const index = subscribersCopy.findIndex((child) => child.id === id);
    subscribersCopy[index].isChecked = isChecked;
    setSubscribers(subscribersCopy);
  };

  useEffect(() => {
    if (!isTeacher) {
      getIndParent({
        variables: {
          where: {
            parent: {
              email: {
                equals: user.email,
              },
            },
          },
        },
      });
    }
    if (isTeacher) {
      getStudents({
        variables: {
          where: {
            id: user.organizations[0].id,
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTeacher, user.email, getIndParent]);

  return { subscribers, selectSubscriber };
};
